module.exports = __webpack_public_path__ + "static/media/leftArrow.0785faef.svg";